import React from "react";

import '../styles/Homepage.css';

import Button from "../../components/scripts/Button";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faGithub, faLinkedin, faTwitter, faMedium } from '@fortawesome/free-brands-svg-icons'
import { faFilePdf } from "@fortawesome/free-solid-svg-icons";

import my_cv from '../../utils/Sourabh_CV.pdf';

class Homepage extends React.Component{

    componentDidMount() {
        const elements = document.querySelectorAll('.slide-up-fade-in');
        elements.forEach(element => {
          element.classList.add('slide-up-fade-in');
        });
    }
    
    render(){
        const {person, links} = this.props;
        return(
            <div className="homepage-div">
                <header className="tc ph4 w-100 slide-up-fade-in">
                    <p className=" title tc">
                        {person.first_name}{person.last_name}
                    </p>
                    <p className="home-description">
                        {person.description}
                    </p>
                    <div className="social-icons center">
                        <a className="animate-grow" href={links.github} target="_blank">
                            <FontAwesomeIcon className="icons font_sec_color" icon={faGithub} />
                        </a>
                        <a className="animate-grow" href={links.linkedin} target="_blank">
                            <FontAwesomeIcon className="icons font_sec_color" icon={faLinkedin} />
                        </a>
                        <a className="animate-grow" href={links.twitter} target="_blank">
                            <FontAwesomeIcon className="icons font_sec_color" icon={faTwitter} />
                        </a>
                        <a className="animate-grow" href={links.medium} target="_blank">
                            <FontAwesomeIcon className="icons font_sec_color" icon={faMedium} />
                        </a>
                        <a className="animate-grow" href={my_cv} target="_blank" download={'Sourabh_CV'}>
                            <FontAwesomeIcon className="icons font_sec_color" icon={faFilePdf} />
                        </a>
                    </div>
                    <div className="mam_div center">
                        <Button text={'More about me'} link={'#aboutpage'}/>
                    </div>
                </header>
            </div>
        );
    }
}

export default Homepage;